<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="800" persistent fluid scrollable content-class="round-2xl")
  v-card(height="75vh")
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Add new medicine
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.py-3
      v-form(ref="form")
        div.text-md.font-semibold.neutral700--text.mt-2 Medication details
        v-row.mt-2
          v-col(cols="6")
            div.text-sm.font-semibold.neutral500--text {{ $t('name') }}
            v-text-field.text-sm.mt-2.round-xl(v-model="medicine.name" :placeholder="$t('name')" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
          v-col(cols="6")
            div.text-sm.font-semibold.neutral500--text Generic name
            v-text-field.text-sm.mt-2.round-xl(v-model="medicine.generic_name" placeholder="Generic name" outlined dense height="48" hide-details="auto")
          v-col(cols="6")
            div.text-sm.font-semibold.neutral500--text Category
            y-select.mt-2(v-model="medicine.category" placeholder="Category" :items="[{ text: 'Medication', value: 'medication' }, { text: 'Equipment', value: 'equipment' }, { text: 'Consumable', value: 'consumable' }]" item-text="text" item-value="value" :rules="rules.not_empty_select")
          v-col(cols="6")
            div.text-sm.font-semibold.neutral500--text Group
            medication-group-dropdown.mt-2(v-model="medicine.groups" :error="false" menu-height="250")
          v-col(cols="6")
            div.text-sm.font-semibold.neutral500--text Unit of measure
            medication-unit-of-measure-dropdown.mt-2(v-model="medicine.uom" :error="false" field-class="round-xl" menu-height="250")

    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Save" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'
import MedicationGroupDropdown from '@/components/clinic/inventory/MedicationGroupDropdown.vue'
import MedicationUnitOfMeasureDropdown from '@/components/clinic/inventory/MedicationUnitOfMeasureDropdown.vue'

export default {
  components: { PhoneInput, MedicationGroupDropdown, MedicationUnitOfMeasureDropdown },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stock: {
      default: null
    },
    product: {
      default: null
    }
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      showAddmedicine: false,
      medicine: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      this.isFetching = true
      let data = {
        product: {
          name: this.medicine.name,
          uom: this.medicine.uom
        },
        generic_name: this.medicine.generic_name,
        category: this.medicine.category,
        groups: this.medicine.groups ? this.medicine.groups.map(m => m.id) : [],
        price_tiers: []
      }
      this.$axios.post(`/clinics/${this.company.slug}/medications`, data)
        .then(() => {
          this.closeDialog()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
</style>